module.exports = __webpack_public_path__ + "img/torso.b9a0f8d2.png";